import { createFileRoute } from "@tanstack/react-router";
import { ErrorState } from "@/ui/States";
import { useService } from "@/features/services/useService";
import { DeploymentsPanel } from "@/features/deployments/DeploymentsPanel";

export const Route = createFileRoute(
  "/_app/o/$orgId/projects/$projectId/services/$serviceId/deployments",
)({
  component: DeploymentsScreen,
});

function DeploymentsScreen() {
  const { orgId, projectId, serviceId } = Route.useParams();
  const service = useService(orgId, projectId, serviceId);

  if (service.isError) {
    return <ErrorState error={service.error} onRetry={() => void service.refetch()} />;
  }
  const svc = service.data?.service;
  if (!svc) return null;

  return <DeploymentsPanel orgId={orgId} projectId={projectId} service={svc} />;
}
